import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AudioPlayer from '../../components/AudioPlayer';
import useStyles from './styles';
import { getAudioList } from '../../store/system/actions';
import { selectFiles, selectIsPlaying } from '../../store/entities/selectors';
import Playlist from '../../components/Playlist';
import FilterContainer from '../../components/FilterContainer';
import Header from '../../components/Header';
import HeadContent from '../../components/HeadContent';
import MiniFilterList from '../../components/MiniFilterList';
import TemporaryDrawer from '../../components/TemporaryDrawer';

export default function Dashboard(props: any) {
  const dispatch = useDispatch();
  const files = useSelector(selectFiles);
  const isPlaying = useSelector(selectIsPlaying);
  const classes = useStyles();

  React.useEffect(() => {
    dispatch(getAudioList({}));
    // TODO: remove elint-disable
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes.root}>
      <Header />
      <HeadContent />
      <TemporaryDrawer />
      <div className={classes.content}>
        <div className={classes.audio}>
          <MiniFilterList />
          <Playlist />
        </div>
        <div className={classes.filter}>
          <FilterContainer />
        </div>
      </div>
      {files && isPlaying && <AudioPlayer tracks={files} />}
    </div>
  );
}
